import React, { Component } from "react";
import { Route, withRouter, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import AppLayout from "../../layout/AppLayout";
import Dashboards from "./dashboards";
import Pages from "./pages";
import secondMenu from "./second-menu";
import blankPage from "./blank-page";


class App extends Component {
  render() {
    const { match } = this.props;
    console.log(this.props.userRole);
    return (
      <AppLayout>
        <Switch>
          {this.props.userRole !== undefined && this.props.userRole === true ? 
          <Redirect exact from={`${match.url}/`} to={`${match.url}/dashboards`} /> :
          <Redirect exact from={`${match.url}/`} to={`${match.url}/pages/redeemVouchers`} />}
           {this.props.userRole !== undefined && this.props.userRole === true ? null :
           <Route path={`${match.url}/dashboards`} component={Dashboards} />}
           {this.props.userRole !== undefined && this.props.userRole === true ? null :
          <Route path={`${match.url}/pages`} component={Pages} />}
          {this.props.userRole !== undefined && this.props.userRole === true ? null :
          <Route path={`${match.url}/second-menu`} component={secondMenu} />}
          <Route path={`${match.url}/blank-page`} component={blankPage} />

          <Redirect to="/error" />
        </Switch>
      </AppLayout>
    );
  }
}
const mapStateToProps = ({ menu,settings }) => {
  const { containerClassnames } = menu;
  const { userRole } = settings;
  return { containerClassnames,userRole };
};

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(App)
);
